import {useCallback, useEffect, useState} from 'react';
import {PagewebError} from '../errors/PagewebError.class';
import {AppThunk} from '../state/store';
import useTypedDispatch from './useTypedDispatch';

export function useThunkDispatch(customErrorHandler?: any) {
  const dispatch = useTypedDispatch();
  const [error, setError] = useState();

  const dispatchWithErrorHandling = useCallback(
    async (action: AppThunk<any>) => {
      try {
        return await dispatch(action).unwrap();
      } catch (error) {
        setError(error);
      }
    },
    [dispatch]
  );

  useEffect(() => {
    if (error) {
      if (customErrorHandler) {
        customErrorHandler(error);
      } else {
        throw new PagewebError(error);
      }
    }
  }, [customErrorHandler, error]);

  return dispatchWithErrorHandling;
}
